import { useCallback } from "react";
import { useLoginStore } from "../store/useLoginStore";
import { getEndpointConfiguration, request } from "../utils";

interface LoginResponse {
  data?: { returnUrl: string };
};

const parseOtp = (x: string | undefined) =>
  (x?.length === 6 ? (x.slice(0, 3) + "-" + x.slice(3, 6)) : x)?.toUpperCase() ?? undefined;

export const useLoginAction = () => {
  const endpoints = getEndpointConfiguration();

  const {
    setLoginHasFailed,
    setSubmitButtonLoading,
    validationErrors,
    loginData
  } = useLoginStore();

  const doLogin = useCallback(async (attachment?: File | null) => {
    const isOtplessLogin = !!attachment

    const loginRequestData = {
      ...loginData,
      otp: isOtplessLogin ? undefined : parseOtp(loginData.otp),
      temporaryPassword: isOtplessLogin  && endpoints.isCloud ? parseOtp(loginData.temporaryPassword) : undefined
    };

    const isValidOtplessLoginData = !validationErrors.userInfo && (!!loginData.temporaryPassword || !endpoints.isCloud);
    const isValidOtplessLogin = isOtplessLogin && isValidOtplessLoginData;

    if (validationErrors.any && !isValidOtplessLogin) {
      setLoginHasFailed(true);
      return;
    }

    const formData = new FormData();
    if (isOtplessLogin) {
      formData.append("idDocument", attachment);
    }

    formData.append("loginData", JSON.stringify(loginRequestData));

    try {
      setLoginHasFailed(false);
      setSubmitButtonLoading(true);

      const result = await request.post<LoginResponse>(
        endpoints.loginEndpoint,
        { body: formData }
      );

      const redirectUrl = result?.data?.returnUrl;
      if (redirectUrl) {
        const isRelativeCloudUrl = endpoints.isCloud && redirectUrl.startsWith('/');
        const redirectDestination = isRelativeCloudUrl ? new URL(redirectUrl, endpoints.sec).href : redirectUrl;
        
        window.location.href = redirectDestination;

        return;
      }
    } catch (error) {
      console.log(error);
    }
    
    setLoginHasFailed(true);
    setSubmitButtonLoading(false);
  }, [endpoints, validationErrors, loginData, setLoginHasFailed, setSubmitButtonLoading]);

  return { doLogin };
};